import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import moment from "moment";
import events from "./rules/events.json";
import metricEventDetails from "./rules/metricEventDetails.json";
import instanceChangeEventDetails from "./rules/instanceChangeEventDetails.json";

const instanceStateCPUUtilization = metricEventDetails.EventId;

const rules = [
  {
    RuleName:
      "Notify Ops team and scale application when standby Instances are critically low",
    Enabled: true,
    RuleTargets: ["i-3p2vqn1aofzsfh4"],
    RuleConditions: [
      { Operator: "gt", Predicate: "Threshold", Type: "Metric", Values: [60] },
      {
        Type: "DateTime",
        Predicate: "day",
        Operator: "eq",
        Values: ["Tuesday"],
      },
    ],
    RuleActions: [
      {
        Type: "Day2NotificationAction",
        Payload: {
          Message: "Rule Rule1 triggered for application HR-App-Production",
          Title: "Notification for rule Rule1",
          Scope: ["Self", "Full Access"],
          NotificationChannel: ["inapp"],
        },
      },
    ],
    EventId: instanceStateCPUUtilization,
    RuleType: "Day2MetricRule",
    MetricType: "Instance State Changed",
    BoundaryType: "Application",
    BoundaryValue: "1",
    CreatedAt: "2021-02-10T20:02:56+05:30",
    CreatedBy: "aba1d5e5-70f5-4189-b971-a2749aa76f01",
    DepartmentId: "319d813b-21d3-4f1a-911e-d2be7a662b07",
    RuleId: "35047a83-502a-47e6-85e5-1dc19c4a692d",
    RuleStatus: "Active",
    RuleStatusInfo: "Actived",
    UpdatedAt: "2021-02-10T20:02:56+05:30",
  },
  {
    RuleName:
      "Run diagnostics and notify Ops team when expected traffic load is higher",
    Enabled: true,
    RuleTargets: ["mi-3nxfzb6ogpcxci"],
    RuleConditions: [
      { Operator: "gt", Predicate: "Threshold", Type: "Metric", Values: [80] },
      {
        Type: "DateTime",
        Predicate: "month",
        Operator: "in",
        Values: ["Feb", "Mar"],
      },
    ],
    RuleActions: [
      {
        Type: "Day2NotificationAction",
        Payload: {
          Message:
            "Rule Rule2gfdasdf triggered for application HR-App-Production",
          Title: "Notification for rule Rule2gfdasdf",
          Scope: ["Full Access"],
          NotificationChannel: ["inapp"],
        },
      },
    ],
    EventId: instanceStateCPUUtilization,
    RuleType: "Day2MetricRule",
    MetricType: "Instance Terminated",
    BoundaryType: "Application",
    BoundaryValue: "1",
    CreatedAt: "2021-02-10T20:03:30+05:30",
    CreatedBy: "aba1d5e5-70f5-4189-b971-a2749aa76f01",
    DepartmentId: "319d813b-21d3-4f1a-911e-d2be7a662b07",
    RuleId: "af97b950-7167-48bc-b1d6-e9192b447eb5",
    RuleStatus: "Active",
    RuleStatusInfo: "Actived",
    UpdatedAt: "2021-02-10T20:03:30+05:30",
  },
  {
    RuleName: "File an Ops ticket when database connections exceed max count",
    Enabled: true,
    RuleTargets: ["i-iafni02lo9sxzba", "mi-rtyxgis1m2ch2w"],
    RuleConditions: [
      { Operator: "gt", Predicate: "Threshold", Type: "Metric", Values: [90] },
      { Type: "DateTime", Predicate: "date", Operator: "in", Values: [1, 2] },
    ],
    RuleActions: [
      {
        Type: "Day2TaskAction",
        Payload: {
          ResourceIds: ["i-bcrwhhn7h2jbuwg"],
          Action: "start",
          TaskRefId: "3484f47d-037f-55d8-bfe1-0ea30df4d9a3",
          ScopeId: "14a6531d-9101-4c87-983b-146a89eabc5b",
          ApplicationId: "1",
          RuleMetadata: {
            Category: "Compute",
            ResourcePath: "/compute/instance",
          },
        },
      },
    ],
    EventId: instanceStateCPUUtilization,
    RuleType: "Day2MetricRule",
    MetricType: "Auto Scaling Group ",
    BoundaryType: "Application",
    BoundaryValue: "1",
    CreatedAt: "2021-02-11T16:23:51+05:30",
    CreatedBy: "aba1d5e5-70f5-4189-b971-a2749aa76f01",
    DepartmentId: "319d813b-21d3-4f1a-911e-d2be7a662b07",
    RuleId: "1a62f93c-40b6-4bfb-b658-36da80364c63",
    RuleStatus: "Active",
    RuleStatusInfo: "Actived",
    UpdatedAt: "2021-02-11T16:23:51+05:30",
  },
  {
    RuleName: "Notify Ops Team when there are unexpected backend errors",
    Enabled: true,
    RuleTargets: ["i-bcrwhhn7h2jbuwg", "i-vn9g4he8n7ya3ox"],
    RuleConditions: [
      { Operator: "gt", Predicate: "Threshold", Type: "Metric", Values: [92] },
      {
        Type: "DateTime",
        Predicate: "month",
        Operator: "in",
        Values: ["Jan", "Feb"],
      },
      {
        Type: "DateTime",
        Predicate: "day",
        Operator: "eq",
        Values: ["Monday"],
      },
    ],
    RuleActions: [
      {
        Type: "Day2TaskAction",
        Payload: {
          ResourceIds: ["i-vn9g4he8n7ya3ox"],
          Action: "stop",
          TaskRefId: "f56098f6-52cb-5975-b30e-628bf5ed2662",
          ScopeId: "14a6531d-9101-4c87-983b-146a89eabc5b",
          ApplicationId: "1",
          RuleMetadata: {
            Category: "Compute",
            ResourcePath: "/compute/instance",
          },
        },
      },
      {
        Type: "Day2NotificationAction",
        Payload: {
          Message: "Rule Rule4 triggered for application HR-App-Production",
          Title: "Notification for rule Rule4",
          Scope: ["Self"],
          NotificationChannel: ["inapp"],
        },
      },
    ],
    EventId: instanceStateCPUUtilization,
    RuleType: "Day2MetricRule",
    MetricType: "Instance State Changed",
    BoundaryType: "Application",
    BoundaryValue: "1",
    CreatedAt: "2021-02-11T16:25:01+05:30",
    CreatedBy: "aba1d5e5-70f5-4189-b971-a2749aa76f01",
    DepartmentId: "319d813b-21d3-4f1a-911e-d2be7a662b07",
    RuleId: "1fce42f9-48ce-4043-a075-076d618f631b",
    RuleStatus: "Active",
    RuleStatusInfo: "Actived",
    UpdatedAt: "2021-02-11T16:25:01+05:30",
  },
];

export const getEventConditionsData = (id) => {
  const data = [metricEventDetails, instanceChangeEventDetails];
  const event = data.find((ele) => ele.EventId === id) || metricEventDetails;
  return event || {};
};

const eventsData = events;

export const createRule = (data) => {
  const rule = { ...data };
  rule.CreatedAt = moment().format();
  rule.CreatedBy = "aba1d5e5-70f5-4189-b971-a2749aa76f01";
  rule.DepartmentId = "319d813b-21d3-4f1a-911e-d2be7a662b07";
  rule.RuleId = uuidv4();
  rule.RuleStatus = "Active";
  rule.RuleStatusInfo = "Actived";
  rule.UpdatedAt = moment().format();
  return rule;
};

const commonProperties = {
  ApplicationId: null,
  BlueprintId: null,
  Category: "EC2",
  enabled: true,
  isImported: false,
  metadata: {},
  owner: "MontyCloud",
};

export const getAppTasks = () => {
  return [
    {
      ...commonProperties,
      actionId: "3484f47d-037f-55d8-bfe1-0ea30df4d9a3",
      name: "Add Node",
      type: "CloudFormationUpdate",
      description: "This action adds a node to the already launched ES stack",
      IsQuickAction: true,
    },
    {
      ...commonProperties,
      actionId: "f56098f6-52cb-5975-b30e-628bf5ed2662",
      name: "Backup",
      type: "RunCommand",
      description:
        "This action calls the runcommand to create elastic search backup",
      IsQuickAction: true,
    },
    {
      ...commonProperties,
      actionId: "4ebc6ca4-c7de-5dec-8d45-67806ffafffc",
      name: "Restore Backup",
      description:
        "This action calls the runcommand to restore elastic search backup",
      type: "RunCommand",
      IsQuickAction: true,
    },
    {
      ...commonProperties,
      actionId: "4ebc6ca4-c7de-5dec-8d45-67806ffafffc",
      name: "Configure Alerts",
      description:
        "This actions will be used to create a alarm for the elastic search",
      type: "CloudFormationNew",
      IsQuickAction: true,
    },
  ];
};

export const reorderTasks = (order) => {
  return;
};

export const updateTasks = (isQuickAction) => {
  return;
};

export const getRules = () => rules;
export const getEventsMetadata = () => eventsData;
